import { cn } from '@/lib/utils'

/**
 * Page Header Component
 *
 * Consistent header for all dashboard pages.
 * Includes title, optional description, and action buttons area.
 *
 * Usage:
 * ```jsx
 * <PageHeader
 *   title="Dashboard"
 *   description="Overview of your accounts and activity"
 * >
 *   <Button>Export</Button>
 * </PageHeader>
 * ```
 */
export function PageHeader({ title, description, children, className }) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-start justify-between gap-3 border-b border-border px-4 py-4 sm:items-center sm:px-6',
        className
      )}
    >
      <div className="min-w-0">
        <h1 className="truncate font-heading text-2xl font-semibold text-foreground">{title}</h1>
        {description && (
          <p className="mt-1 max-w-[72ch] text-pretty text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {children && <div className="flex shrink-0 items-center gap-2">{children}</div>}
    </div>
  )
}

export default PageHeader


